import { createActions, createReducer } from 'reduxsauce'
import Immutable from 'seamless-immutable'

export const INITIAL_STATE = Immutable({
  data: {},
  loading: false,
})

const { Types, Creators } = createActions({
  syncFreeCheckoutPromotions: null,
  unSyncFreeCheckoutPromotions: null,

  setFreeCheckoutPromotions: ['data'],
})

export const syncFreeCheckoutPromotionsReducer = state => state.set('loading', true)

export const unSyncFreeCheckoutPromotionsReducer = state => state.set('loading', false)

export const setFreeCheckoutPromotionsReducer = (state, { data }) =>
  state.set('data', data).set('loading', false)

export const freeCheckoutReducer = createReducer(INITIAL_STATE, {
  [Types.SYNC_FREE_CHECKOUT_PROMOTIONS]: syncFreeCheckoutPromotionsReducer,
  [Types.UN_SYNC_FREE_CHECKOUT_PROMOTIONS]: unSyncFreeCheckoutPromotionsReducer,

  [Types.SET_FREE_CHECKOUT_PROMOTIONS]: setFreeCheckoutPromotionsReducer,
})

export const FreeCheckoutTypes = Types
export default Creators



// WEBPACK FOOTER //
// ./src/reducers/freeCheckoutReducer.js